module.exports = "//static.hsappstatic.net/LoginUI/static-1.15674/img/okta-logo.svg"